import React, { useEffect, useState } from "react";
import { getPageData } from "../api/pageService";
import { sleep } from "../utils/sleep";
import { Title, Meta, Link as SeoLink } from "react-head";
import Service from '../components/Service';

const Services = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
          const fetchPageData = async () => {
            try {
              // simulate network delay (3 sec)
              //await sleep(3000);
    
              const data = await getPageData("services"); // asynchronous call
              setPageData(data);
            } catch (err) {
              setError("Failed to load services page data.");
            } finally {
              setLoading(false);
            }
          };
      
          fetchPageData();
  }, []);
  
  return (
    <>
     <Title>{pageData? pageData.seo.title:''}</Title>
           <Meta
             name="description"
             content={pageData?pageData.seo.description:''}
           />
      <SeoLink rel="canonical" href={pageData ? pageData.seo.canonical : ''} />
      
      {/* Services */}
      <Service />
    </>
  );
};

export default Services;
